import { CSSProperties } from 'react';
import { getPx } from '@shared/util/actionSheet';
import { MBDimensions } from '@shared/util/dimensions';
import { UnvalidatedStyles } from '../styles';

/*
    We want to position the reaction picker above the
    button that triggered it showing. However, we don't want
    that parts of the picker become invisible because they
    overflow the screen.
*/
export function pickerPositionFromButtonPosition(
  buttonPosition: { x: number; y: number; width: number; height: number },
  // Padding between picker and button below (useful eg when there is a chat bubble inbetween)
  bottomMargin: number = 0,
): CSSProperties {
  const centerX = buttonPosition.x + buttonPosition.width / 2;
  const width = UnvalidatedStyles.pickerWidth;

  const position = 'absolute';
  let top: number | undefined;
  let bottom: number | undefined;
  let left: number | undefined;
  let right: number | undefined;

  if (buttonPosition.y + bottomMargin > UnvalidatedStyles.pickerHeight) {
    bottom = MBDimensions.height - buttonPosition.y + bottomMargin;
    // We don't want the reaction picker to be colliding with the status bar
    // (eg when reacting to a message that is very far up on the screen).
    if (bottom + UnvalidatedStyles.pickerHeight > MBDimensions.height) {
      top = 0;
      bottom = undefined;
    }
  } else {
    // When we show reactions for a message that is extremely tall (eg multiple images),
    // the picker at the top won't be visible when eg viewing the bottom of the message.
    // This will cause buttonPosition.y to be large and negative, and the picker would
    // render way above the screen's extent. Instead, we show the picker in the middle
    // of the screen.
    bottom = MBDimensions.height / 2;
  }

  if (centerX - width / 2 < 0) {
    left = 0;
  } else if (centerX + width / 2 > MBDimensions.width) {
    right = 0;
  } else {
    left = centerX - width / 2;
  }

  return {
    position,
    top: getPx(top),
    bottom: getPx(bottom),
    left: getPx(left),
    right: getPx(right),
  };
}
